var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCircleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88869 24.2945C7.06674 24.2945 6.28823 24.1129 5.5888 23.7888L2.2275 24.5027L2.93028 21.1348C2.60395 20.4331 2.42129 19.6512 2.42129 18.8271C2.42129 15.811 4.86597 13.3652 7.88312 13.3652C10.9003 13.3652 13.345 15.811 13.345 18.8271C13.345 21.8431 10.8992 24.2889 7.88312 24.2889",
    stroke: "white",
    strokeWidth: 1.67062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36412 13.3862C6.92641 12.4339 6.6825 11.3904 6.6825 10.2911C6.6825 5.81716 10.6898 2.22754 15.5925 2.22754C20.4952 2.22754 24.5025 5.81716 24.5025 10.2911C24.5025 12.9351 23.0969 15.2629 20.9396 16.7308C20.9407 17.5728 20.9385 18.7077 20.9385 19.8994L17.4424 18.1776C16.8444 18.2923 16.2262 18.3546 15.5925 18.3546C14.8006 18.3546 14.0355 18.2522 13.3026 18.0762",
    stroke: "white",
    strokeWidth: 1.67062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34084 18.8945C5.36258 18.9162 5.36258 18.9515 5.34084 18.9732C5.31909 18.995 5.28383 18.995 5.26208 18.9732C5.24033 18.9515 5.24033 18.9162 5.26208 18.8945C5.28383 18.8727 5.31909 18.8727 5.34084 18.8945",
    stroke: "white",
    strokeWidth: 1.67062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84677 18.8945C7.86852 18.9162 7.86852 18.9515 7.84677 18.9732C7.82502 18.995 7.78976 18.995 7.76802 18.9732C7.74627 18.9515 7.74627 18.9162 7.76802 18.8945C7.78976 18.8727 7.82502 18.8727 7.84677 18.8945",
    stroke: "white",
    strokeWidth: 1.67062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3527 18.8945C10.3745 18.9162 10.3745 18.9515 10.3527 18.9732C10.331 18.995 10.2957 18.995 10.274 18.9732C10.2522 18.9515 10.2522 18.9162 10.274 18.8945C10.2957 18.8727 10.331 18.8727 10.3527 18.8945",
    stroke: "white",
    strokeWidth: 1.67062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5925 11.1869C15.5925 10.4551 16.0447 10.0586 16.498 9.75345C16.9413 9.45497 17.3845 9.06627 17.3845 8.35013C17.3845 7.36001 16.5826 6.55811 15.5925 6.55811C14.6024 6.55811 13.8005 7.36001 13.8005 8.35013",
    stroke: "white",
    strokeWidth: 1.67062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5925 13.8752C15.5312 13.8752 15.4811 13.9253 15.4811 13.9866C15.4811 14.0478 15.5312 14.0979 15.5925 14.0979C15.6538 14.0979 15.7039 14.0478 15.7039 13.9866C15.7039 13.9253 15.6538 13.8752 15.5925 13.8752",
    stroke: "white",
    strokeWidth: 1.67062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircleIcon);
export default __webpack_public_path__ + "static/media/HelpCircleIcon.ad26009010096f85638ea285d21f99fb.svg";
export { ForwardRef as ReactComponent };